import React, {memo} from 'react';
import PropTypes from 'prop-types';

import {CSSTransition, SwitchTransition} from 'react-transition-group';

import {useComponent} from './hooks/useComponent';

import './SearchDateDisplay.less';

const SearchDateDisplay = memo(function SearchDateDisplay(props) {
    const {
        className,
        labelClassName,
        valueClassName,
        label,
        value,
        transitionKey,
        transitionClassNames,
        transitionMode,
        transitionTimeout
    } = useComponent(props);

    return (
        <dl className={className}>
            <dt className={labelClassName}>{label}</dt>
            <dd className={valueClassName}>
                <SwitchTransition mode={transitionMode}>
                    <CSSTransition
                        key={transitionKey}
                        classNames={transitionClassNames}
                        timeout={transitionTimeout}
                    >
                        <span>{value}</span>
                    </CSSTransition>
                </SwitchTransition>
            </dd>
        </dl>
    );
});

SearchDateDisplay.propTypes = {
    locale: PropTypes.string,
    label: PropTypes.string.isRequired,
    date: PropTypes.string,
    dateFormatOptions: PropTypes.objectOf(PropTypes.string),
    isActive: PropTypes.bool
};

SearchDateDisplay.defaultProps = {
    label: 'Date',
    dateFormatOptions: {
        month: 'short',
        day: 'numeric',
        weekday: 'short'
    }
};

SearchDateDisplay.whyDidYouRender = true;

export {SearchDateDisplay};
